export const userServiceUrl = "https://providerservice.mothrly.com/api";
